import React, { useContext } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import { AuthContext } from '../context/AuthContext';

const Authorization = ({ open, onClose }) => {
    const {subdomain, userData} = useContext(AuthContext)

    const handleAuthClick = async (event) => {
        const domain = localStorage.getItem('subDomain')
        window.open(`https://${domain}.nodoji.com`, '_blank');
    }

    const handleReloadClick = async (event) => {
        // Use redirect to capture SameSite=Lax cookies (they're sent with top-level navigation)
        const domain = localStorage.getItem('subDomain');
        const currentUrl = encodeURIComponent(window.location.href);
        window.location.href = `https://${domain}.nodoji.com/sso/init-session-redirect?redirect=${currentUrl}`;
    }
    return(
        <Dialog open={open} 
        onClose={(event, reason) => {
            if (reason !== 'backdropClick') {
                onClose();
            }
        }}  
        aria-labelledby="settings-dialog-title" fullWidth PaperProps={{
            style: {
              width: '490px',
              maxWidth: '100%',
            },
          }} className="setting-dialog">
            <DialogTitle id="settings-dialog-title" className="d-flex justify-content-between mb-4">
                <div className="d-flex align-items-center">
                    <span style={{marginLeft:"10px"}}>Authentication</span>
                </div>
                <img
                    style={{ height: '22px', width: '20px', cursor: 'pointer' }}
                    src={`${process.env.PUBLIC_URL}/images/close.png`}
                    alt="close"
                    className="close-icon"
                    role="button"
                    onClick={(e) => {
                        e.stopPropagation();
                        onClose();
                    }}
                />
            </DialogTitle>
            <DialogContent>
                <span style={{fontSize: "16px"}}>Please authenticate by clicking on below authenticate button</span>
                <div className="mt-1 mb-3 row justify-content-center">
                    <Button variant="primary" type="submit" onClick={handleAuthClick} style={{backgroundColor: '#317CFF', textTransform: 'none'}} className="mt-3 w-55 p-2 theme-btn-email">
                        {'Authenticate'}
                    </Button>
                </div>
                <div  className='mt-5'>
                    <span style={{fontSize: "16px"}}>After authentication click on below button to reload the page</span>
                </div>
                <div className="mt-1 mb-3 row justify-content-center">
                    <Button variant="primary" type="submit" onClick={handleReloadClick} style={{backgroundColor: '#317CFF', textTransform: 'none'}} className="mt-3 w-55 p-2 theme-btn-email">
                        {'Reload'}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
}

export default Authorization;